import { borderCss, mobileBorderCss } from 'common/utils/styleUtilsNew'
import { BorderEntityInterface } from 'src/shared/schemas/border.schema'
import styled, { css } from 'styled-components'

type HorizontalLineUiProps = BorderEntityInterface

const HorizontalLineUi = styled.hr<HorizontalLineUiProps>`
  ${borderCss}
  ${p => p.theme.phone} {
    ${mobileBorderCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileBorderCss}
    `}
`

export default HorizontalLineUi
